export const loadingContent = `w-full h-full flex justify-center align-cennter`;

export const highlight = `w-80`;
